import UploadAvatarModal from './js/UploadAvatarModal';
import 'cropper/dist/cropper.css';

export default UploadAvatarModal;
